import { useQuery } from "@tanstack/react-query";
import { CacheKey } from "../models/cacheKey";
import { Response } from "../models/response";
import { CheckInDetail, CheckInDetailDto } from "../models/checkInDetail";
import HttpClient from "../utils/network";
import { OnSiteApi } from "../apis/onsite";

export function useCheckInDetail({
  artistId,
  eventId,
  rewardId,
}: {
  artistId?: number;
  eventId?: number;
  rewardId?: number;
}) {
  const {
    data: checkInDetail,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: [CacheKey.getCheckInDetail, eventId, rewardId],
    queryFn: async () => {
      if (
        artistId !== undefined &&
        eventId !== undefined &&
        rewardId !== undefined
      ) {
        const response = new Response<CheckInDetailDto>(
          await HttpClient.request(
            OnSiteApi.event(artistId, eventId, rewardId),
          ),
        );
        return new CheckInDetail(response.data);
      } else {
        return null;
      }
    },
  });

  return { checkInDetail: checkInDetail, isLoading, isError, error };
}
